import React from "react";
import { styled } from "@mui/system";
import { Typography, Container, Card, Box, Grid } from "@mui/material";
import { motion } from "framer-motion"; // Import motion from framer-motion
import Footer from "../Footer";

const CustomCard = styled(motion(Card))({
  minHeight: "250px",  // Adjusted height for consistent card size
  padding: "20px",
  textAlign: "center",
  borderRadius: "12px",
  backdropFilter: "blur(10px)",
  backgroundColor: "rgba(52, 39, 153, 0.13)",
  boxShadow: "0px 4px 20px rgba(29, 7, 70, 0.67)",
  border: "1px solid rgba(29, 7, 70, 0.67)",
  color: "white",
  display: "flex",  // Flexbox to keep text content centered
  flexDirection: "column",
  justifyContent: "center",
});

const CardContainer = styled(Container)({
  marginTop: "40px",
});

const consultancyContent = [
  {
    title: "Implementation",
    description: `ITSM, HRSD, ITOM implementation, ITIL Framework based configuration, Development & Customization, Third-party tools integration, Development using App Engine Studio, Integration with IoT as per client requirements.`,
    color: "#fff",
  },
  {
    title: "Application Development",
    description: `Development using Instance scan module, Identify affected scripts causing issues, Best practice implementation.`,
    color: "#007bff",
  },
  {
    title: "Performance Improvement",
    description: `Administration & configuration, Daily activities support, Performance analysis.`,
    color: "#007bff",
  },
  {
    title: "Administration & Support",
    description: `Daily activities support, Administration & configuration, Performance analysis.`,
    color: "#fff",
  },
];

const Consultancy = () => {
  return (
    <>
      <Box className="consultancy-container">
        <CardContainer>
          <motion.div
            whileHover={{
              scale: 1.05, // Optional: to slightly enlarge the card when hovering
              transition: { duration: 0.3 },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "#95a9bd",
                fontFamily: "'Inter', sans-serif",
                textAlign: "center",
                mb: 4,
                transition: "text-shadow 0.3s ease", // Transition for smooth effect
              }}
              whileHover={{
                textShadow: "0px 0px 20px rgba(8, 53, 99, 1)", // Glow effect
              }}
            >
              ServiceNow as a Service
            </Typography>
          </motion.div>

          <Grid container spacing={3}>
            {consultancyContent.map((content, index) => (
              <Grid item xs={12} md={6} key={index}>
                <CustomCard
                  initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      color: content.color,
                      fontFamily: "'Inter', sans-serif",
                    }}
                  >
                    {content.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Inter', sans-serif",
                      color: "#babbbf",
                      textAlign: "left",
                      marginTop: "25px",
                    }}
                  >
                    {content.description}
                  </Typography>
                </CustomCard>
              </Grid>
            ))}
          </Grid>
        </CardContainer>
      </Box>
      <Footer />
    </>
  );
};

export default Consultancy;
